/*
 * @see https://namespaces.chainagnostic.org/xrpl/README
 */

// if the value neeeds to be change make sure you will update mapCaipNamespaceToLegacyNetworkName as well
export const CAIP_NAMESPACE = 'xrpl';
export const CAIP_XRPL_CHAIN_ID = 'mainnet';
